import { type PrimitiveProps } from '@react-three/fiber';
import { type AVPModel, GLTFModel } from '@billykwok/3d';

import { AnimatedPrimitive } from '@/utils/react-three-fiber/animations';
import { useGLTF } from '@/utils/react-three-fiber/useGLTF';

const modelPath = `/models/${GLTFModel.AVP}`;

export function AnimatedAVP(props: Partial<PrimitiveProps>) {
  const { scene } = useGLTF<AVPModel, string>(modelPath);
  return <AnimatedPrimitive object={scene} dispose={null} {...props} />;
}

useGLTF.preload(modelPath);
